var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showHelp)?_c('span',{staticClass:"characters-available",class:{'danger': _vm.counter < 10}},[_vm._v(_vm._s(_vm.counter)+" Caracteres Disponibles")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }